<section class="users-view">

	<div class="row">
		
		<div class="col-12">
			<div class="card">
				<div class="card-content">
					<div class="card-body">
						<div>
							<h4>{{ assets_data?.name }}</h4>
						</div>
						<div class="row">
							
							<div class="col-12">
								<table class="table table-borderless">
									<tbody>
										
										<tr>
											<td>Type :</td>
											<td class="users-view-latest-activity">
												{{ assets_data?.type }}
											</td>
										</tr>
										
										<tr>
											<td>Notes :</td>
											<td class="users-view-latest-activity" [innerText]="assets_data?.notes">
											</td>
										</tr>
										<tr>
											<td>Admin Notes :</td>
											<td class="users-view-latest-activity" [innerText]="assets_data?.admin_notes">
											</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		
	</div>
</section>